export const environment = {
  production: true,
  showBuildInfo: false,
  serverURL: 'https://landingapi.sanjagh.com/api',
  serverRootUrl: 'https://landingapi.sanjagh.com/api',
};
